<template>
  <div class="mx-auto">
    <v-card flat class="pa-2">
      <v-container class="pa-5">
        <div class="my-3">
          <h4>{{ preview ? 'Detail' : 'Tambah' }} Peserta IKM Pengawas</h4>
          <v-alert v-if="!preview" class="my-2" color="blue" text>
            <v-row>
              <v-col class="grow my-auto">
                <div class="black--text">
                  Silakan pilih pengawas yang ingin ditambahkan menjadi peserta Diklat IKM
                </div>
              </v-col>
              <v-col class="shrink">
                <v-btn class="success" depressed @click="onPilihPengawas">
                  <v-icon left>mdi-account</v-icon>
                  Pilih Pengawas
                </v-btn>
              </v-col>
            </v-row>
          </v-alert>
          <template v-if="$isObject(pengawas)">
            <v-list two-line>
              <v-list-item dense class="px-0">
                <v-list-item-content>
                  <v-row>
                    <v-col cols="12" lg="4">
                      <span class="indigo--text" style="font-size: 13px;"> Nama Pengawas </span>
                      <div class="black--text font-weight-medium my-1" style="font-size: 15px">
                        {{ $getDeepObj(pengawas, 'ptk.nama') || '-' }}
                      </div>
                    </v-col>
                    <v-col cols="12" lg="4">
                      <span class="indigo--text" style="font-size: 13px;"> Akun SIMPKB </span>
                      <div class="black--text my-1" style="font-size: 15px">
                        {{ $getDeepObj(pengawas, 'ptk.email') || '-' }}
                      </div>
                    </v-col>
                    <v-col cols="12" lg="4">
                      <span class="indigo--text" style="font-size: 13px;"> NIP </span>
                      <div class="black--text my-1" style="font-size: 15px">
                        {{ $getDeepObj(pengawas, 'ptk.nip') || '-' }}
                      </div>
                    </v-col>
                    <v-col cols="12" lg="4">
                      <span class="indigo--text" style="font-size: 13px;"> Biodata Pengawas </span>
                      <div class="body-2 mt-1">
                        <span class="grey--text text--darken-1">Jenis Kelamin: </span>
                        {{
                          $getDeepObj(pengawas, 'ptk.kelamin')
                            ? $getDeepObj(pengawas, 'ptk.kelamin') === 'L'
                              ? 'Laki - laki'
                              : 'Perempuan'
                            : '-'
                        }}
                      </div>
                      <div class="body-2">
                        <span class="grey--text text--darken-1">Usia: </span>
                        {{ $getDeepObj(pengawas, 'ptk.umur') || '-' }}
                      </div>
                      <div class="body-2">
                        <span class="grey--text text--darken-1">Pendidikan Terakhir: </span>
                        {{ $getDeepObj(pengawas, 'ptk.m_kualifikasi.keterangan') || '-' }}
                      </div>
                    </v-col>
                    <v-col cols="12" lg="4">
                      <span class="indigo--text" style="font-size: 13px;"> Instansi Tugas </span>
                      <div class="body-2 mt-1">
                        {{ $getDeepObj(pengawas, 'tugas.instansi.nama') || '-' }}
                      </div>
                      <div class="body-2">
                        <span class="grey--text text--darken-1">Jenjang binaan: </span>
                        {{
                          $fkata(($getDeepObj(pengawas, 'tugas.jenjangs') || []).map((jenjang) => jenjang.singkat)) ||
                            '-'
                        }}
                      </div>
                    </v-col>
                    <v-col cols="12" lg="4">
                      <span class="indigo--text" style="font-size: 13px;"> Status Kepesertaan </span>
                      <div class="body-2">
                        <span class="grey--text text--darken-1">Fasilitator PSP: </span>
                        <span :class="[`${pengawas.pa ? 'red' : 'green'}--text`]">
                          {{ pengawas.pa ? `Ya, Angkatan ${pengawas.pa.gelombang}` : 'Tidak' }}
                        </span>
                      </div>
                      <div class="body-2">
                        <span class="grey--text text--darken-1">Diklat PKP: </span>
                        <span :class="[`${pengawas.pkp ? 'red' : 'green'}--text`]">
                          {{ pengawas.pkp ? `Pernah Ikut, Angkatan ${pengawas.pkp.gelombang}` : 'Belum Ikut' }}
                        </span>
                      </div>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </template>
        </div>
      </v-container>
    </v-card>
    <popup-kandidat ref="kandidat" />
  </div>
</template>
<script>
import PopupKandidat from '../popup/Kandidat';
import { mapActions } from 'vuex';
export default {
  components: { PopupKandidat },
  props: {
    preview: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pengawas: {},
    };
  },
  computed: {},
  methods: {
    ...mapActions('ikmPengawas', ['fetchKandidat']),

    reset(ptk_id = '') {
      this.$set(this, 'pengawas', {});
      if (this.preview && ptk_id) {
        this.fetchKandidat({ ptk_id }).then((kandidat) => {
          this.pengawas = Object.assign({}, kandidat);
        });
      }
    },

    getValue() {
      return Object.assign({}, this.pengawas);
    },

    onPilihPengawas() {
      this.$refs.kandidat.open().then((resp) => {
        this.fetchKandidat({ ptk_id: resp.ptk_id }).then((kandidat) => {
          this.pengawas = Object.assign({}, kandidat);
        });
      });
    },
  },
};
</script>
